import { memo } from 'react';

export const AssetModalHeaderSeparator = memo(() => {
  return <div className="h-8 w-px bg-gray-6" data-testid="ASSET_MODAL_HEADER_SEPARATOR" />;
});

AssetModalHeaderSeparator.displayName = 'AssetModalHeaderSeparator';
